'use client';

import type { TOC } from '@mcdougald/mdx-plugins';

import { SegmentGroup, SegmentGroupItem } from '@mcdougald/ui/src';
import { useRouter } from 'next/navigation';

import { useScrollspy } from '@/hooks/use-scrollspy';

type TableOfContentsProps = {
  toc: TOC[];
};

const TableOfContents = (props: TableOfContentsProps) => {
  const { toc } = props;
  const tocUrls = toc.map((item) => item.url);
  const activeId = useScrollspy(tocUrls, { rootMargin: '0% 0% -80% 0%' });
  // const t = useTranslations();
  const router = useRouter();

  console.log('[TableOfContents]', { toc, activeId, tocUrls });

  return (
    <div className="hidden pl-4 lg:block">
      <div className="mb-4">{'On this page'}</div>
      <SegmentGroup
        orientation="vertical"
        value={activeId}
        onValueChange={(details) => {
          router.push(`#${details.value}`);
        }}
        className="text-sm"
      >
        {toc.map((item) => {
          const { title, url, depth } = item;
          const paddingL = depth * 12;

          // console.log('ToC', { paddingL, title, depth });
          return (
            <SegmentGroupItem
              key={url}
              value={url}
              style={{
                paddingLeft: `${paddingL}px`,
              }}
            >
              {title}
            </SegmentGroupItem>
          );
        })}
      </SegmentGroup>
    </div>
  );
};

export default TableOfContents;
